import React, { useContext, useEffect, useState } from "react";
import Modal, { CommonModalProps, ModalContext } from "..";
import { Box, Button, MenuItem, Stack, CircularProgress, Typography } from "@mui/material";
import AutocompleteSearchCatalog from "../../Search/AutocompleteSearchCatalog/autocomplete-search-catalog";
import { assetService, basketService, cacheService, searchService } from "../../../Core/Api/services";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { CreateStandaloneRequest } from "../../../Core/Api/Types/create-standalone-request";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { ObjectStatus } from "../../../Core/Api/Types/object-status";
import { ObjectClass } from "../../../Core/Api/Types/object-class";
import { IDbBaseMetadataValueInfos } from "../../../Core/Api/Types/i-db-base-metadata-value-infos";
import { useSelector } from "react-redux";
import {
  GetTimelineActions,
  SetFps,
  SetLoadedSequence,
  SetSequenceName,
  generateMetadata,
} from "../../../Redux/Reducers/redux-slice-timetool";
import { CreateNewDbMetadataValue } from "../../../Core/Utils/asset-object-utils";
import { BaseMetadataType } from "../../../Core/Api/Types/base-metadata-type";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useDispatch } from "react-redux";
import FormInputText from "../../Forms/FormInputText/form-input-text";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { GetFormIsValid, GetSectionIsValid } from "../../../Redux/Reducers/redux-slice-form-validation";
import FormInputSelect from "../../Forms/FormInputSelect/form-input-select";
import FormSection from "../../Forms/FormSection/form-section";
import ConfigFormIcon from "../../Config/ConfigFormIcon";
import TableSkeleton from "../../Table/TableSkeleton";
import { PlatformMode } from "../../../Core/Api/Types/platform-mode";
import { SearchRequestNative } from "../../../Core/Api/Types/search-request-native";
import { AddToLazyLoad, InitState } from "../../../Redux/Reducers/redux-slice-asset";
import { useTranslation } from "react-i18next";
import ModalConfirmAction, { ModalConfirmActionProps } from "../ModalConfirmAction/modal-confirm-action";
import { useNavigate } from "react-router";
import { routePaths } from "../../../Router/router";
import AssetTreeView from "../../TreeView/TitleTreeView/asset-tree-view-2";
import {
  GetSelectedItems,
  GetTreeObj,
  SetSelectedItems,
  SetTreeObj,
  TreeContext,
} from "../../../Redux/Reducers/redux-slice-tree";

export type ModalTimetoolConfigElementProps = {
  onConfirm?: (fps: number, name: string) => void;
  sequenceName: string;
  currentFps: number;
};

export type ModalTimetoolConfigProps = CommonModalProps<ModalTimetoolConfigElementProps>;

const ModalTimetoolConfig = React.forwardRef<any, ModalTimetoolConfigProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onConfirm, sequenceName, currentFps } = props;
  const dispatch = useAppDispatch();
  const [rootTreeId, setRootTreeId] = useState<number>();

  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const navigate = useNavigate();
  const selectedItems = useAppSelector(GetSelectedItems(TreeContext.Timetool));
  const [name, setName] = useState<string>(sequenceName);
  const [fps, setFps] = useState<number>(currentFps);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    dispatch(SetSequenceName(name));
  }, [name]);

  useEffect(() => {
    dispatch(SetFps(fps));
  }, [fps]);

  const timelineActions = useSelector(GetTimelineActions);
  const enqueueCustomSnackbar = useCustomSnackbar();

  const formId = "modal-timetool-config";
  const formSectionSequenceConfig = useAppSelector(GetSectionIsValid(formId, "sectionSequenceConfig"));

  const isFormValid = useAppSelector(GetFormIsValid(formId));

  React.useEffect(() => {
    dispatch(SetSelectedItems({ context: TreeContext.Timetool, selectedIds: [], replace: true }));
    if (cacheService.GetPlatformMode() === PlatformMode.Distribution) return;
    else {
      const rootId = cacheService.GetPlatformDriveHeadId();
      setRootTreeId(rootId);
    }
    // let request: SearchRequestNative = new SearchRequestNative({
    //   hideTitleWithoutAsset: false,
    //   onlyConfidential: false,
    //   pattern: "*",
    //   outputLayer: ObjectLayer.Head,
    // });

    // searchService.SearchBasic(request).then((rep) => {
    //   if (rep.results && rep.results.length > 0) {
    //     setRootTreeId(rep.results[0].id);
    //   }
    // });
  }, []);

  //   useEffect(() => {
  //     if (cacheService.GetPlatformMode() === PlatformMode.Distribution) return;
  //     if (mainContentId !== -1) {
  //       SetIsFetching(true);
  //       assetService.GetObjectLightById(mainContentId, 2).then((result) => {
  //         if (result.graph && result.graph.childObjects) {
  //           dispatch(AddToLazyLoad(result.graph.childObjects.map((x) => x.id.toString()) || []));
  //           dispatch(SetTreeObj({ obj: result.graph, context: TreeContext.Timetool }));
  //           setShowGraph(true);
  //           SetIsFetching(false);
  //         }
  //       });
  //     }

  //     return () => {
  //       dispatch(InitState());
  //     };
  //   }, [mainContentId]);

  const handleClickTitle = (data: any) => {
    setRootTreeId(data.id);
  };

  const handleSave = (addToBasket: boolean) => {
    if (!selectedItems || !rootTreeId) return;
    setIsSaving(true);
    const sequenceSegmentMetadata = cacheService.GetMetadata().find((x) => x.tagName === "sequenceSegments");
    assetService
      .CreateStandalone(
        new CreateStandaloneRequest({
          objs: [
            new DbAssetObjectInfos({
              isNew: true,
              hidden: false,
              isDeleted: false,
              type: ObjectType.TimetoolSequence,
              objectType: ObjectType.TimetoolSequence,
              layer: ObjectLayer.Asset,
              status: ObjectStatus.Accepted,
              name: name,
              parentObjectId: selectedItems[0],
              parentTitleId: cacheService.GetPlatformMode() === PlatformMode.Distribution ? rootTreeId : null,
              classification: ObjectClass.Mezz,
              allParentObjectIds:
                cacheService.GetPlatformMode() === PlatformMode.Distribution ? [rootTreeId, selectedItems[0]] : null,
              metadata: [
                CreateNewDbMetadataValue(
                  sequenceSegmentMetadata!.id,
                  BaseMetadataType.DbSequenceMetadataValueInfos,
                  "sequenceSegments",
                  generateMetadata(timelineActions, fps) as IDbBaseMetadataValueInfos[]
                ),
              ],
              trash: false,
            }),
          ],
        })
      )
      .then((res) => {
        if (res.createdObjects && res.success) {
          SetLoadedSequence(res.createdObjects[0]);
          enqueueCustomSnackbar(t("alert:success.sequenceSaved"), "success");
          if (addToBasket) {
            basketService
              .AddItemToBasket({ objectId: res.createdObjects[0].id, episodesNbList: null, externalContractId: null })
              .then((res) => {
                if (res.success) {
                  if (openModal)
                    openModal<ModalConfirmActionProps>(ModalConfirmAction, {
                      onConfirm: () => {
                        navigate(routePaths.basket.path);
                      },
                      title: t("modal:title.confirmGoToBasket"),
                      canConfirmWithoutComment: true,
                      displayComment: false,
                      closeModal: () => {
                        closeModal();
                      },
                    });
                } else {
                  enqueueCustomSnackbar(res.message ?? t("alert:error.addTobasket"), "error");
                  closeModal();
                }
              });
          } else closeModal();
        }
        setIsSaving(false);
      })
      .catch((err) => {
        setIsSaving(false);
      });
  };

  const handleCloseModal = () => {
    if (openModal)
      openModal<ModalConfirmActionProps>(ModalConfirmAction, {
        onConfirm: () => closeModal(),
        title: t("modal:title.confirmCloseModalLoseConfiguration"),
        canConfirmWithoutComment: true,
        displayComment: false,
        closeModal: () => {},
      });
  };

  return (
    <Modal
      hideHeader
      footer={
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={() => closeModal()}>{t("common:close")}</Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={isSaving && <CircularProgress size={20} />}
            disabled={selectedItems.length === 0 || isSaving || !isFormValid}
            onClick={() => handleSave(false)}
          >
            {t("common:save")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={isSaving && <CircularProgress size={20} />}
            disabled={selectedItems.length === 0 || isSaving || !isFormValid}
            onClick={() => handleSave(true)}
          >
            {t("button:saveAndAddToBasket")}
          </Button>
        </Stack>
      }
      closeModal={handleCloseModal}
      title={t("modal:title.sequenceConfiguration")}
      reference={ref}
      width={900}
    >
      <Stack sx={{ width: "100%" }}>
        <Box sx={{ width: "100%", marginTop: "12px" }}>
          <Stack spacing={1} mb={1.5} display={"flex"} direction={"row"} flexWrap={"nowrap"}>
            <FormSection
              defaultExpanded
              icon={<ConfigFormIcon icon="delivery" />}
              title={t("modal:title.sequenceConfiguration")}
              status={formSectionSequenceConfig ? "complete" : "warning"}
              statusText={formSectionSequenceConfig ? t("common:configured") : t("common:configurationRequired")}
              sx={{ width: "100%", display: "flex", flexDirection: "column" }}
            >
              <FormInputText
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                label={t("field:label.sequenceName")}
                validationProps={{
                  formId: formId,
                  formSectionId: "sectionSequenceConfig",
                  fieldId: "sequence-name",
                  required: true,
                  minLength: 3,
                }}
              />
              <FormInputSelect
                disabled
                value={fps}
                label={t("field:label.sequenceFrameRate")}
                stackProps={{}}
                onChange={(e) => {
                  setFps(parseFloat(e.target.value.toString()));
                }}
                validationProps={{
                  formSectionId: "sectionSequenceConfig",
                  formId: formId,
                  fieldId: "select-fps",
                }}
              >
                <MenuItem key={0} value={23.976}>
                  23.976
                </MenuItem>
                <MenuItem key={1} value={24}>
                  24
                </MenuItem>
                <MenuItem key={2} value={25}>
                  25
                </MenuItem>
                <MenuItem key={3} value={29.97}>
                  29.97
                </MenuItem>
              </FormInputSelect>
            </FormSection>
          </Stack>
          {cacheService.GetPlatformMode() === PlatformMode.Distribution && (
            <AutocompleteSearchCatalog
              layer={ObjectLayer.Title}
              withPortal={true}
              enableSearchCallback={false}
              onValueProposalClick={handleClickTitle}
              sx={{ padding: "0px 24px 12px 24px", width: "100%", position: "relative" }}
            />
          )}
          {rootTreeId ? (
            <Box sx={{ overflowY: "scroll", maxHeight: "40vh", marginTop: "12px" }}>
              <AssetTreeView
                context={TreeContext.Timetool}
                rootObjectId={rootTreeId}
                multiselect={false}
                unselectableIds={[rootTreeId]}
              />
            </Box>
          ) : (
            <Stack pt={2} height={"100px"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
              <Typography variant="body1" color="text.primary">
                Rechercher un titre où enregistrer votre compilation
              </Typography>
            </Stack>
          )}
        </Box>
      </Stack>
    </Modal>
  );
});

export default ModalTimetoolConfig;
